import { render, staticRenderFns } from "./SweetSpotSetup.vue?vue&type=template&id=38bd3a20&scoped=true"
import script from "./SweetSpotSetup.vue?vue&type=script&lang=js"
export * from "./SweetSpotSetup.vue?vue&type=script&lang=js"
import style0 from "./SweetSpotSetup.vue?vue&type=style&index=0&id=38bd3a20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bd3a20",
  null
  
)

export default component.exports